import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Faq } from '../../../graphql.generated';

export const constructGoogleFaqSchema = (faqs: (Faq | null)[] | null) => {
    let entity = '';

    faqs?.forEach((i, index) => {
        entity =
            entity +
            `{
            "@type": "Question",
            "name": "${i?.question}",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "${
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    i?.answer ? documentToPlainTextString(i.answer) : ''
                }"
            }
        }${index + 1 === faqs.length ? `` : `,`}`;
    });

    const schema = `
    {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            ${entity}
        ]
    }
    `;

    return schema;
};
